

export default class HTTPRequestExecuter {

    static makeRequest(method, raw_url, params, headers, body) {
        const url = new URL(raw_url)
        url.search = new URLSearchParams(params).toString();
        return fetch(
            url,
            {
                mode: 'cors',
                method: method,
                headers: headers,
                body: JSON.stringify(body)
            });
    }

    static makeBodilessRequest(method, raw_url, params, headers) {
        const url = new URL(raw_url)
        url.search = new URLSearchParams(params).toString();
        return fetch(
            url,
            {
                mode: 'cors',
                method: method,
                headers: headers
            });
    }

}